import BaseComponent from "../../../baseComponent.js";
import DashboardService from "../../../../core/services/dashboardService";

import styles from "./copy-to-dashboard.scss";


export default class CopyToDashboard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      dashboards: []
    }
  }

  componentDidMount() {
    DashboardService.getAllDashboards()
      .then(dashboards => {
        const usersDashboard = dashboards.filter(d => !d.originalDashboard)
          .sort((a, b) => a.tabPosition - b.tabPosition);
        this.refs.select.value = usersDashboard[0].persistenceId;
        this.setState({dashboards: usersDashboard});
        $(this.refs.select).material_select();
      });
  }

  copy() {
    const targetDashboardId = this.refs.select.value;
    if (targetDashboardId.trim().length > 0) {
      this.props.onCopy(targetDashboardId, this.state.title);
      this.setState({title: ""});
      this.refs.select.value = this.state.dashboards[0].persistenceId;
      $(this.refs.select).material_select();
    }
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="preview-field-list__title">Copy to dashboard</div>
        <div className="row">
          <div className="input-field col s12">
            <input type="text" id="title" value={this.state.title}
                   onChange={e => this.setState({title: e.target.value})}/>
            <label htmlFor="title">Title (Optional)</label>
          </div>
          <div className="input-field col s12">
            <select className="invalid" ref="select">
              {
                this.state.dashboards.map((d, i) => <option value={d.persistenceId} key={i}>{d.title}</option>)
              }
            </select>
            <label>Target dashboard</label>
          </div>
          <div className="col s12">
            <a className={["waves-effect waves-light btn", styles.button].join(" ")} onClick={this.copy}>COPY</a>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/data-bank/dataset-detail/content/copyToDashboard.jsx